import React, { useContext } from "react";
import Map, { DataType } from "charts/Map";
import { DataContext } from "App";
import { useHistory } from "react-router-dom";
import Adcodes from "assets/json/adcode.json";

export interface CityMapProps {
  mapName: keyof typeof Adcodes;
}

const CityMap: React.FC<CityMapProps> = ({ mapName }) => {
  const appData = useContext(DataContext);
  const history = useHistory();

  const handleMapChange = (name: keyof typeof Adcodes) => {
    const url = name === "全国" || !Adcodes[name] ? "/" : `/?mapName=${name}`;
    history.push(url);
  };

  return (
    <Map
      data={appData?.dimension?.region_city as DataType[]}
      mapName={mapName}
      onMapChange={handleMapChange}
    />
  );
};

export default CityMap;
